import ReactECharts from "echarts-for-react";
import type { EChartsOption } from "echarts-for-react/src/types";
import type { BacktestItem } from "epsm-api-types/models";
import { useEffect, useState } from "react";
import { Spinner } from "@/components/Spinner";
import type { GetOptions } from "@/components/widgets/Backtest/types.ts";

export const BacktestChart = ({
	data,
	getOptions,
	isLoading = false,
}: {
	data: BacktestItem[];
	getOptions: GetOptions;
	isLoading: boolean;
}) => {
	const [options, setOptions] = useState<EChartsOption>({});

	useEffect(() => {
		if (data.length && !isLoading) {
			setOptions(getOptions(data));
		}
	}, [data, isLoading, getOptions]);

	return isLoading ? (
		<Spinner />
	) : (
		<ReactECharts
			option={options}
			showLoading={isLoading}
			style={{ height: "100%", width: "100%" }}
		/>
	);
};
